/**
 * Yan menude es anlamli arama (Faz 2.3).
 *
 * Arama yalnizca kullanicinin zaten gordugu menu ogelerini suzer; yeni sayfa,
 * rota ya da yetki eklemez. Bir oge; kendi adi, ust grubunun adi veya ceviri
 * dosyasindaki arama kelimeleri (`menuSearch.keywords.<anahtar>`) aranan
 * kelimelerin hepsini iceriyorsa eslesir. Ornek: "masa" → B2B Randevularim +
 * Masa ve Saat Sec.
 */

type Translate = (key: string) => string;

export interface SearchableMenuItem {
    title: string;
    to?: string;
    classsChange?: string;
    content?: SearchableMenuItem[];
}

const TURKISH_CHAR_FOLD: Record<string, string> = {
    ç: 'c',
    ğ: 'g',
    ı: 'i',
    ö: 'o',
    ş: 's',
    ü: 'u',
    â: 'a',
    î: 'i',
    û: 'u',
};

/** "Görüşme İSTEĞİ" ve "gorusme istegi" ayni metne iner. */
export const normalizeMenuSearchText = (value: string): string =>
    value
        .toLocaleLowerCase('tr')
        .replace(/[çğıöşüâîû]/g, (char) => TURKISH_CHAR_FOLD[char])
        .replace(/\s+/g, ' ')
        .trim();

const keywordsFor = (titleKey: string, t: Translate): string => {
    const key = `menuSearch.keywords.${titleKey.replace(/^menu\./, '')}`;
    const value = t(key);
    // Ceviri yoksa t() anahtarin kendisini doner; o metin aramaya karismasin.
    return value === key ? '' : value;
};

const searchTextOf = (item: SearchableMenuItem, t: Translate): string =>
    `${t(item.title)} ${keywordsFor(item.title, t)}`;

const matchesAllTokens = (text: string, tokens: string[]): boolean => {
    const normalized = normalizeMenuSearchText(text);
    return tokens.every((token) => normalized.includes(token));
};

const hasChildren = (item: SearchableMenuItem): boolean =>
    Array.isArray(item.content) && item.content.length > 0;

/**
 * Menu agacini aramaya gore suzer. Bos aramada liste aynen doner.
 * Arama sirasinda bolum basliklari gizlenir; grup yalnizca eslesen alt ogeleriyle kalir.
 */
export function filterMenuBySearch<T extends SearchableMenuItem>(items: T[], query: string, t: Translate): T[] {
    const tokens = normalizeMenuSearchText(query).split(' ').filter(Boolean);
    if (tokens.length === 0) return items;

    return items.flatMap((item) => {
        if (item.classsChange === 'menu-title') return [];

        if (hasChildren(item)) {
            const parentText = searchTextOf(item, t);
            const content = item.content!.filter((child) =>
                matchesAllTokens(`${searchTextOf(child, t)} ${parentText}`, tokens),
            );
            return content.length > 0 ? [{ ...item, content }] : [];
        }

        return matchesAllTokens(searchTextOf(item, t), tokens) ? [item] : [];
    });
}
